import React, { useState } from 'react';
import './App.css';
import BoardMemberPosts from './BoardMemberPosts';
import AnnualData from './AnnualData';
import EditCompanyInfo from './EditCompanyInfo';
import GeneralMeetingOfMembers from './GeneralMeetingOfMembers';
import Events from './Events';
import { __ } from './translations';
import { Building, CalendarDays, FileText, Users, Bell } from 'lucide-react';
import CompanyManagement from './CompanyManagement';
//import CarbonFootprint from './CarbonFootprint';
import ImportantNews from './ImportantNews';
import Studies from './Studies';
import KnowledgeBase from './KnowledgeBase';
import AppTour from './AppTour';
import SurveysAnalysis from './SurveysAnalysis';
import AuthChecker from './components/AuthChecker';


// Tab data structure for easier management
const tabs = [
  { id: 'company', label: __('Company'), icon: Building },
  { id: 'annual', label: __('Annual Data'), icon: CalendarDays },
  { id: 'restricted-page', label: __('General Meeting of Members'), icon: Users },
  { id: 'important-news', label: __('Important News'), icon: FileText },
  // { id: 'posts', label: __('Member Posts / News'), icon: FileText },
  { id: 'surveys-analysis', label: __('Surveys and Analysis'), icon: FileText },
  { id: 'studies', label: __('Studies'), icon: FileText },
  { id: 'knowledge-base', label: __('Knowledge Base'), icon: FileText },
  { id: 'events', label: __('Events'), icon: Bell }
];

function App() {
  const [activeTab, setActiveTab] = useState('company');
  const {
    userData,
    companyData,
    nonce,
    restURL,
    documentData,
    isUserLoggedIn,
    isBoardMember,
    memberType,
    isAdmin,
    loginURL
  } = boardMemberData;
console.log('boardMemberData', boardMemberData);
  // If the user is not logged in, show a login message and button
  if (!isUserLoggedIn) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="bg-white p-8 rounded-lg shadow-md">
          <p className="mb-4 text-gray-600">{__('You need to be logged in to view this content.')}</p>
          <a
            href={loginURL}
            className="inline-flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            {__('Log In')}
          </a>
        </div>
      </div>
    );
  }

  // If the user is logged in but doesn't have the right permissions
  if (!isBoardMember && !isAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="bg-white p-8 rounded-lg shadow-md">
          <p className="text-gray-600">{__('You do not have permission to view this content.')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto">
      {/* Add the AuthChecker component with a 5-minute interval */}
      <AuthChecker
        checkInterval={5 * 60 * 1000}
        onSessionExpired={() => console.log("Session expired, showing warning")}
      />
      <div className="min-h-screen bg-gray-50">
        {/* Header with welcome message */}
        <div className="bg-white shadow">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <h1 className="text-2xl font-semibold text-gray-900">
              {__('Welcome')}, {userData.displayName}!
            </h1>
          </div>
        </div>

        {/* Main content area */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Tab Navigation */}
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
              {tabs.map(tab => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`
                    group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm
                    ${activeTab === tab.id
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }
                  `}
                  >
                    <Icon
                      className={`
                      -ml-0.5 mr-2 h-5 w-5
                      ${activeTab === tab.id
                          ? 'text-blue-500'
                          : 'text-gray-400 group-hover:text-gray-500'
                        }
                    `}
                    />
                    <span>{tab.label}</span>
                  </button>
                );
              })}
            </nav>
          </div>

          {/* Tab Content */}
          <div className="mt-8">
            {activeTab === 'company' && (
              isAdmin ? <CompanyManagement /> : <EditCompanyInfo
                companyData={companyData}
                nonce={nonce}
                restURL={restURL}
                documentData={documentData}
                memberType={memberType}
              />
            )}

            {activeTab === 'annual' && (
              <AnnualData />
            )}
            {activeTab === 'restricted-page' && (
              <GeneralMeetingOfMembers restURL={restURL} nonce={nonce} />
            )}
            {activeTab === 'important-news' && <ImportantNews />}
            {/* {activeTab === 'posts' && (
            <BoardMemberPosts />
          )} */}
            {activeTab === 'surveys-analysis' && (
              <SurveysAnalysis />
            )}

            {activeTab === 'studies' && <Studies />}
            {activeTab === 'knowledge-base' && <KnowledgeBase />}

            {activeTab === 'events' && (
              <>
              <Events restURL={restURL} nonce={nonce} />
                {/* <ReviewManagementDashboard /> */}
                </>
            )}
          </div>
        </div>

      </div>
      <AppTour />

      {/* Contact Persons */}
      <div className="mt-8 bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">{__('Contact Persons')}</h2>
        <ul className="list-disc list-inside text-gray-700 text-sm">
          <li className='mb-2'>
            <strong>Anna Lutowska</strong> - tel: 517013750, <a href="mailto:skladki@igwp.org.pl" className="text-blue-600 hover:underline">skladki@igwp.org.pl</a>
          </li>
          <li className='mb-2'>
            <strong>Natalia Przepierska</strong> - tel: 517013749, <a href="mailto:n.przepierska@igwp.org.pl" className="text-blue-600 hover:underline">n.przepierska@igwp.org.pl</a>
          </li>
          <li className='mb-2'>
            <strong>Maciej Dadok</strong> - tel: 668466032, <a href="mailto:m.dadok@igwp.org.pl" className="text-blue-600 hover:underline">m.dadok@igwp.org.pl</a>
          </li>
        </ul>
      </div>
      {/* Footer - created by Muskey - Web Solutions */}
      <div className="mt-8 text-right d-inline-block w-full text-sm text-gray-500">
        <span>{__('Created by ')}</span>
        <span>
          <a
            href="https://muskey.pl"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            {__('Muskey - Web Solutions')}
          </a>
        </span>      
    </div>
    </div>
  );
}

export default App;